'use strict';//Indicating browser should run only in java script mode
//http://stackoverflow.com/questions/20369377/how-to-use-http-get-in-angularjs-correctly-in-specific-for-an-external-api-cal

//*******PURPOSE: The purpose of the service is to handle each and every http wcf calls related to login functionality
//*******EFFECTIVE FILES: ../Views/Rx/..
//*******CREATED BY: Mahesh P
//*******CREATED DATE: 01/08/2014
//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

angular.module('EMR.RxModule').service('RxCommonService', ['CommonPostService', 'CommonService', '$injector', function (CommonPostService, CommonService, $injector) {
    /**
     * This methd to is Used Update the Unsigned Non Medication Orders Count
     * @author : Supraja Kapa
     * @since : 08252020
     * @param {any} isSignOff
     */
	this.RxServiceUpdateUnsignedMedicationOrdersCountOfUser = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.INSERTUPDATEDELETE;
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_Rx_Inbox_DashBoard_Reports_API() + "UpdateUnsignedMedicationOrdersCountOfUser", postData).then(
			function (result) {
				return result;
			});
	};

	//*******PURPOSE: THIS IS USED GET THE FACILITIES LIST THAT ARE RELATED TO THE POS 11
	//*******CREATED BY: SIVA PRASAD
	//*******CREATED DATE:08/06/2015
	//*******MODIFIED DEVELOPER: DATE - NAME - WHAT IS MODIFIED; xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx

	this.rxserviceGetEPCSEnabledforThisPractice = function () {
		var EMRCommonFactory = $injector.get("EMRCommonFactory");

		return EMRCommonFactory.GetEPCSDetailsforThisPractice().then(function (result) {
			if (hasValue(result)) {
				return result;
			}
			else {
				var postdatatoService = {
					practicemodel: EMRPracticeModel,
				}
				postdatatoService.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST; // CURSO
				return CommonPostService.httpPostData('POST', CommonPostService.EHR_Rx_EPCS_ControlledSubStances_API() + "GetEPCSEnabledforThisPractice", postdatatoService).then(
					function (result) {
						EMRCommonFactory.SetEPCSDetailsforThisPractice(result);
						return result;
					});
			}
		});


		// var postdatatoService = {
		//     practicemodel: EMRPracticeModel,
		// }
		// postdatatoService.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST; // CURSO

		// return CommonService.PostData('POST', CommonService.EHROrderRx() + "GetEPCSEnabledforThisPractice", postdatatoService).then(
		//function (result) {
		//    return result;

		//});

	

	};
	
	this.GetPrescriptionFormatSettingsInfo = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_Rx_Save_Update_Prescription_API() + "GetPrescriptionFormatSettingsInfo", postData).then(
			function (result) {
				return result;
			});
	};
	this.GetRxFrequencyDetails = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_Rx_Save_Update_Prescription_API() + "GetRxFrequencyList", postData).then(
			function (result) {
				return result;
			});
	};
	
	/**
     * This method is used to get the  refills reqest  from patinet portal count
     * @author : Supraja Kapa
     * @since : 12112023
     * @param {any} isSignOff
     */
	this.RxServiceGetRefillRequestsfromPatientPortalCount = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		postData.ehrAdminCurrentCallingActionType = adminWCFActionCallType.GETLIST;
		
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_Rx_Inbox_DashBoard_Reports_API() + "GetRefillRequestsfromPatientPortalCount", postData).then(
			function (result) {
				return result;
			});
	};

	this.GetUsersLinkedToFacility = function () {
		var postData = {
			LoggedFacilityID: EMRPracticeModel.LoggedFacilityID,
			ehrAdminCurrentCallingActionType: adminWCFActionCallType.GETLIST,
		}
		return CommonPostService.httpPostData('POST', CommonPostService.EHR_LinkUserstoLocationsandPrograms_API() + "GetUsersLinkedToFacility", postData).then(
			function (result) {
				return result;
			});
	};

	this.GetDrugstoReviewandSendERxCount = function(postData) {
		postData.practicemodel = EMRPracticeModel;

		return CommonPostService.httpPostData('POST', CommonPostService.EHR_Send_ERx_API() + "GetDrugstoReviewandSendERxCount", postData).then(
			function (result) {
				return result;
			});
	};
}])